import { Accordion, AccordionButton, AccordionItem, AccordionPanel } from '@chakra-ui/react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

interface BasketItemGridPricesProps {
  hasUpfrontPrice?: boolean;
}
const BasketItemStyles = styled.div<{ hasFlag?: boolean }>`
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
  background-color: #ffffff;
  padding: ${rem('21px')};
  border-radius: ${rem('6px')};
  margin-bottom: ${rem('20px')};

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    ${({ hasFlag }) =>
      hasFlag &&
      css`
        padding-top: ${rem('40px')};
      `}
  }
`;

// THUMBNAIL
export const BasketItemThumbWrapper = styled.div`
  display: flex;
  align-items: center;
  min-height: ${rem('75px')};
`;

export const BasketItemThumb = styled.div<{ hasThumbnail?: boolean }>`
  width: ${rem('50px')};
  height: ${rem('50px')};
  border-radius: ${rem('6px')};
  overflow: hidden;
  flex-shrink: 0;
  margin-right: ${rem('20px')};

  ${({ hasThumbnail }) =>
    !hasThumbnail &&
    css`
      background-color: #eaeaea;
    `}
`;

// ACCORDION
export const BasketAccordion = styled(Accordion)`
  && {
    width: 100%;
  }
`;
export const BasketAccordionItem = styled(AccordionItem)``;
export const BasketAccordionButton = styled(AccordionButton)``;

export const BasketAccordionButtonWrapper = styled.div<{ isExpanded: boolean }>`
  button {
    width: unset;
    padding: ${rem('2px')};

    #basket-accordion-details {
      text-decoration: underline;
      color: var(--mineShaft);
      @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
        display: none;
      }
    }

    #basket-accordion-button {
      margin-left: ${rem('2px')};
      transition: 0.2s ease-out;
      transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'none')};
    }
  }
`;

export const BasketAccordionPanelWrapper = styled.div`
  width: 100%;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg - 1}px) {
    order: 2;
  }
`;

export const BasketAccordionPanel = styled(AccordionPanel)`
  && {
    padding: ${rem('10px')} 0;
  }
`;

export const BasketItemInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`;

export const BasketItemTitle = styled.div`
  display: flex;
  flex-direction: column;
  min-height: ${rem('50px')};
  width: 100%;
  max-width: 100%;

  > h4 {
    flex-shrink: 0;
    max-width: 100%;
    margin: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    align-items: center;
    flex-direction: row;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    max-width: 40%;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    max-width: 46%;
  }
`;

export const BasketItemContents = styled.div<BasketItemGridPricesProps>`
  display: flex;
  justify-content: ${({ hasUpfrontPrice }) =>
      hasUpfrontPrice
        ? `flex-end`
        : `space-between`};
  width: 100%;
  max-width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    grid-row-gap: ${rem('5px')};
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.lg - 1}px) {
    order: 3;
    justify-content: space-between;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    max-width: 60%;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    max-width: 54%;
  }
`;

export const BasketItemGridPrices = styled.div<BasketItemGridPricesProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: grid;
    grid-template-columns: ${({ hasUpfrontPrice }) =>
      hasUpfrontPrice ? `repeat(2, minmax(${rem('170px')}, 1fr))` : `1fr`};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    grid-column: 1 / -1;
    padding-bottom: ${rem('4px')};
    border-bottom: ${rem('1px')} solid #4a4d4e26;
  }
`;

export const BasketItemFlag = styled.div`
  background-color: ${({ theme }) => theme.color.primary1.default};
  position: absolute;
  top: 0;
  right: 0;
  font-family: 'VodafoneLight';
  font-size: ${rem('16px')};
  line-height: ${rem('20px')};
  padding: ${rem('5px')} ${rem('10px')};
  color: #ffffff;
  border-top-right-radius: ${rem('6px')};
  z-index: 0;
  &::before {
    content: '';
    width: ${rem('20px')};
    height: 100%;
    background-color: ${({ theme }) => theme.color.primary1.default};
    position: absolute;
    top: 0;
    left: ${rem('1px')};
    transform: skewX(30deg) translateX(-50%);
    z-index: -1;
  }
`;

export default BasketItemStyles;
